<template>
  <v-card>
    <v-card-title>
      <v-title>Manage Admin</v-title>
    </v-card-title>
    <v-card-text>
      <v-layout wrap>
        <v-flex xs3>
          <v-text-field
            name="Search"
            label="Search"
            v-model="search"
            append-icon="search"
          ></v-text-field>
        </v-flex>
        <v-flex xs2>
          <v-select
            :items="filter"
            label="Filter by..."
            v-model="selected"
            class="ml-5"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="headers"
        :items="filterData()"
        :search="search"
        item-key="index"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <td xs1 md1 lg1>
            <span>
              <!-- {{ props.item.applicationID == 1 ? "Sign On Glass" : "LINK" }} -->
              {{ appName(props.item.applicationID) }}
            </span>
          </td>
          <td xs2 md2 lg2>
            <ValidationProvider
              name="Email"
              rules="required"
              v-slot="{ errors }"
            >
              <v-text-field
                label="Email"
                name="Email"
                :error-messages="errors"
                v-if="isEditing(props)"
                v-model="props.item.customerEmail"
              ></v-text-field>
              <span v-else>{{ props.item.customerEmail }}</span>
            </ValidationProvider>
          </td>
          <td>
            <ValidationProvider
              name="Name"
              rules="required"
              v-slot="{ errors }"
            >
              <v-text-field
                label="Name"
                name="Name"
                :error-messages="errors"
                v-if="isEditing(props)"
                v-model="props.item.customerName"
              ></v-text-field>
              <span v-else>{{ props.item.customerName }}</span>
            </ValidationProvider>
          </td>
          <td>
            <ValidationProvider
              name="Auth Level"
              rules="required"
              v-slot="{ errors }"
            >
              <v-select
                :items="props.item.applicationID == 1 ? SOGLevel : linkLevel"
                label="Select auth level"
                name="Auth Level"
                :error-messages="errors"
                v-if="isEditing(props)"
                v-model="props.item.authGroupName"
              ></v-select>

              <span v-else>{{ props.item.authGroupName }}</span>
            </ValidationProvider>
          </td>
          <td class="pl-3">
            <v-tooltip bottom :disabled="isEditingItem">
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-if="!isEditing(props)"
                  @click="
                    setToEditing(props);
                    isEditingItem = true;
                  "
                  class="my-0 mx-1"
                  v-on="on"
                  :disabled="isEditingItem"
                >
                  <v-icon color="teal">edit</v-icon>
                </v-btn>
              </template>
              <span>Edit email, name, &amp; auth level</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-if="!isEditing(props)"
                  @click="searchAuth0(props.item.customerEmail)"
                  class="my-0 mx-1"
                  v-on="on"
                  :disabled="isEditingItem"
                >
                  <v-icon color="teal">check_circle</v-icon>
                </v-btn>
              </template>
              <span>Check login email</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-if="!isEditing(props)"
                  @click="createAuth(props.item.customerEmail)"
                  class="my-0 mx-1"
                  v-on="on"
                  :disabled="isEditingItem"
                >
                  <v-icon color="teal">add_circle</v-icon>
                </v-btn>
              </template>
              <span>Create login account</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-if="!isEditing(props)"
                  @click="resetPassword(props.item.customerEmail)"
                  class="my-0 mx-1"
                  v-on="on"
                  :disabled="isEditingItem"
                >
                  <v-icon color="teal">refresh</v-icon>
                </v-btn>
              </template>
              <span>Reset login password</span>
            </v-tooltip>

            <v-tooltip bottom :disabled="!isEditingItem">
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-if="isEditing(props)"
                  @click="updateCreds(props.item)"
                  class="my-0 mx-1"
                  v-on="on"
                >
                  <v-icon color="teal">save</v-icon>
                </v-btn>
              </template>
              <span>Save</span>
            </v-tooltip>

            <v-tooltip bottom :disabled="!isEditingItem">
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-if="isEditing(props)"
                  @click="cancelEdit(props)"
                  class="my-0 mx-1"
                  v-on="on"
                >
                  <v-icon color="pink">cancel</v-icon>
                </v-btn>
              </template>
              <span>Cancel</span>
            </v-tooltip>
          </td>
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions class="pr-3 pb-3">
      <v-spacer></v-spacer>
      <v-btn class="primary" @click="addUser()">Create New User</v-btn>
    </v-card-actions>

    <add-user :add="add" @close="close()" @save="save"></add-user>

    <message-alert
      ref="alert"
      :component="!load ? message : newMessage"
    ></message-alert>
  </v-card>
</template>
<script>
import AddUser from '@/components/admin/add-user';
import { mapActions, createNamespacedHelpers } from 'vuex';
import { mapAuthFields, mapDealerFields } from '@/store/modules/orders';
import { httpError } from '../models/httpError';
const { mapActions: mapAuthActions } = createNamespacedHelpers(`orders/auth`);
export default {
  name: 'ManageAdmin',
  components: { AddUser },
  data() {
    return {
      add: false,
      newMessage: {},
      editingIndex: -1,
      customers: [],
      search: '',
      loading: false,
      isEditingItem: false,
      isAddingItem: false,
      linkLevel: ['Customer', 'Dealer', 'Administrators'],
      SOGLevel: ['Dealer', 'Dealer Managers', 'Helpdesk', 'Administrators'],
      application: [
        { id: 1, text: 'Sign On Glass', canAddNew: false },
        { id: 2, text: 'LINK', canAddNew: true },
        { id: 3, text: 'GEEKS LINK', canAddNew: true },
      ],
      filter: ['Sign On Glass', 'LINK', 'GEEKS LINK', 'All'],
      selected: 'All',
      disable: false,
      lastAuth: -2,
      load: false,
      headers: [
        {
          text: 'Application',
          sortable: true,
          value: 'applicationName',
        },
        {
          text: 'Email',
          sortable: true,
          value: 'customerEmail',
        },
        {
          text: 'Customer Name',
          sortable: true,
          value: 'customerName',
        },
        {
          text: 'Auth Level',
          sortable: true,
          value: 'authGroupName',
        },
        {
          text: 'Actions',
          sortable: true,
          value: 'action',
        },
      ],
    };
  },
  methods: {
    ...mapAuthActions([
      'getAuths',
      'updateAuth',
      'setMessage',
      'getDealerAuths',
    ]),
    ...mapActions('orders/dealer', [
      'resetPassword',
      'createAuth',
      'searchAuth0',
      'addNewUser',
    ]),
    appName(appID) {
      switch (appID) {
        case 1:
          return 'Sign on Glass';
        case 2:
          return 'LINK';
        case 3:
          return 'GEEKS LINK';
        default:
          return null;
      }
    },
    getCustomers() {
      let vm = this;
      vm.load = false;

      setTimeout(() => {
        vm.getDealerAuths().then((result) => {
          vm.customers = result.data;
        });
      }, 1000);
    },
    isEditing(props) {
      return this.editingIndex == props.index;
    },
    setToEditing(props) {
      this.lastAuth = this.customers[this.customers.length - 1].authGroupID;
      this.editingIndex = props.index;
    },
    cancelEdit(props) {
      this.editingIndex = -1;
      this.getCustomers();
      this.lastAuth = this.customers[this.customers.length - 1].authGroupID;
      this.isEditingItem = false;
      this.isAddingItem = false;
    },
    addUser(item) {
      this.add = true;
      this.isAddingItem = true;
      this.lastAuth = this.customers[this.customers.length - 1].authGroupID;
    },
    close() {
      this.add = false;
    },
    updateCreds(editedItem) {
      this.updateAuth(editedItem);

      this.isEditingItem = false;
      this.isAddingItem = false;
      this.add = false;
      this.editingIndex = -1;
      this.lastAuth = -2;
    },
    save(editedItem) {
      // this.updateAuth(editedItem);

      let vm = this;

      vm.addNewUser(editedItem)
        .then((x) => {
          if (x) {
            vm.add = false;
            editedItem.customerEmail = null;
            editedItem.customerName = null;
          }
        })
        .finally(() => {
          vm.getCustomers();
          this.isEditingItem = false;
          this.isAddingItem = false;
          this.add = false;
          this.editingIndex = -1;
          this.lastAuth = -2;
        });

      // this.searchAuth0(editedItem.customerEmail).then(data => {
      // 	if (data.httpStatus !== 500) {
      // 		this.setMessage(new httpError({
      // 			message: "E-mail already exists",
      // 			httpStatus: 500
      // 		}));
      // 	} else {
      // 		this.createAuth(editedItem.customerEmail).then(data => {
      // 		});
      // 	}
      // });

      // this.isEditingItem = false;
      // this.isAddingItem = false;
      // this.add = false;
      // this.editingIndex = -1;
      // this.lastAuth = -2;
    },
    filterData() {
      if (this.selected == 'All') return this.customers;
      else {
        switch (this.selected) {
          case 'Sign On Glass':
            return this.customers.filter(
              (x) => x.applicationID === 1 || x.applicationID === 0
            );
          case 'LINK':
            return this.customers.filter((x) => x.applicationID === 2);
          case 'GEEKS LINK':
            return this.customers.filter((x) => x.applicationID === 3);
          default:
            return this.customers;
        }
      }
    },
  },
  computed: {
    ...mapAuthFields(['getAuths', 'updateAuth', 'message']),
    ...mapDealerFields([
      'searchAuth0',
      'createAuth',
      'resetPassword',
      'message',
    ]),
  },
  watch: {
    selected: function () {
      this.filterData();
    },
  },
  mounted() {
    this.getCustomers();
  },
};
</script>
